/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontProductGrid_viewer$ref = any;
export type StorefrontFeaturedSection_viewer$ref = any;
export type StorefrontFeaturedSection_viewer = {
    readonly " $fragmentRefs": StorefrontProductGrid_viewer$ref;
    readonly " $refType": StorefrontFeaturedSection_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontFeaturedSection_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontProductGrid_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'd7f364a176f42757299c334987f84e09';
export default node;
